import React from "react";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useGAEventsTracker } from "../../util/gtag";

export default function CtaSection(props) {
  const GAEventTrackerGetStarted = useGAEventsTracker(
    window.location.pathname + "/Get Started"
  );
  const history = useHistory();

  // const handleGetStart = () => {
  //   const currentUrl = window.location.pathname;
  //   const newUrl = currentUrl.endsWith("/")
  //     ? `${currentUrl}questionnaire`
  //     : `${currentUrl}/questionnaire`;
  //   history.push(newUrl);
  // };
  const handleGetStart = () => {
    const currentUrl = window.location.pathname;
    const newUrl = currentUrl.endsWith("/")
      ? `${currentUrl}questionnaire`
      : `${currentUrl}/questionnaire`;

  // full reload every time
  window.location.href = newUrl;
  };

  return (
    <>
      <style>{`
        .cta-wrapper {
          width: 100%;
          height: 340px; /* thinner height */
          background-image: url('/assets/images/Ready_to_make.png');
          background-size: cover;
          background-position: right center;
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          padding-left: 94px;
        }

        .cta-content {
          max-width: 480px;
          color: white;
        }

        .cta-title {
          font-size: 40px;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 25px;
        }

        .cta-button {
          background-color: ${props?.partner?.secondary_color || "#7ac943"} !important;
          color: white !important;
          font-size: 20px !important;
          font-weight: 600 !important;
          height: 54px !important;
          padding: 0 32px !important;
          border-radius: 10px !important;
        }

        .cta-note {
          margin-top: 18px;
          font-size: 16px;
        }

        /* ---------- Responsive ---------- */

        @media (max-width: 992px) {
          .cta-wrapper {
            height: 260px;
            padding-left: 35px;
            background-position: center right;
          }
          .cta-title {
            font-size: 32px;
          }
        }

        @media (max-width: 768px) {
          .cta-wrapper {
            height: auto;
            padding: 40px 20px;
            background-position: center;
          }
          .cta-title {
            font-size: 30px;
            margin-bottom: 20px;
          }
          .cta-button {
            width: 100% !important;
            height: 50px !important;
          }
          .cta-note {
            text-align: center;
            font-size: 15px;
          }
        }

        @media (max-width: 480px) {
          .cta-title {
            font-size: 26px;
          }
        }
      `}
      </style>

      <div className="cta-wrapper">
        <div className="cta-content">
          <h2 className="cta-title">Ready to make your next move easy?</h2>

          <Button
            variant="contained"
            className="cta-button"
            onClick={() => {
              GAEventTrackerGetStarted("Get started", 1);
              handleGetStart();
            }}
          >
            Submit an Application
          </Button>

          <p className="cta-note">
            It's free and only takes 5 minutes!
          </p>
        </div>
      </div>
    </>
  );
}
